import { render, staticRenderFns } from "./InitialsBadge.vue?vue&type=template&id=700b82a0&"
import script from "./InitialsBadge.vue?vue&type=script&lang=ts&"
export * from "./InitialsBadge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports